<script>
import FormLayout from "../../router/layouts/form";

/**
 * Nav-bar Component
 */
export default {
  components: {
    FormLayout,
  },
  props: {
    resource: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      logoContent: ''
    };
  },
  methods: {
    changeLogo(event) {
      const fileObject = event.target.files[0];

      if (!fileObject) {
        this.logoContent = "";
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        this.resource.image = {
          name: fileObject.name,
          content: btoa(e.target.result)
        };
        this.logoContent = "data:image;base64, " + this.resource.image.content;
      };

      reader.onerror = function (error) {
        alert(error);
      };

      reader.readAsBinaryString(fileObject);
    }
  }
};
</script>

<template>
  <b-card no-body class="mb-0">
    <form-layout @submitted="$emit('submitted')" @cancel="$emit('cancel')" :resource="resource"
                 resource-name="partner">
      <b-row no-gutters class="justify-content-md-center">
        <b-col md="4">
          <b-form-group :label="$t('general.logo')" class="mb-3" label-for="formrow-logo-input">
            <div v-if="logoContent" class="text-center">
              <b-card-img :src="logoContent" class="img-fluid w-auto mb-1" style="max-height: 100px"></b-card-img>
            </div>
            <input class="form-control" type="file" id="formrow-logo-input" accept="image/png, image/jpeg"
                   @change="changeLogo"/>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group label="Nom" class="mb-3" label-for="formrow-name-input">
            <b-form-input id="formrow-name-input" type="text" v-model="resource.name"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="Lien" class="mb-3" label-for="formrow-url-input">
            <b-form-input id="formrow-url-input" type="text" placeholder="https://" v-model="resource.url"
                          pattern="[Hh][Tt][Tt][Pp][Ss]?:\/\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\d{2,5})?(?:\/[^\s]*)?">
            </b-form-input>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row no-gutters class="align-items-center">
        <b-col>
          <b-form-group label="Description" class="mb-3" label-for="formrow-description-input">
            <b-form-textarea id="formrow-description-input" type="text" v-model="resource.description">
            </b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </form-layout>
  </b-card>
</template>